import script from "./ResourcePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcePicker.vue?vue&type=script&setup=true&lang=ts"

import "./ResourcePicker.vue?vue&type=style&index=0&id=51c29d85&scoped=true&lang=css"
script.__scopeId = "data-v-51c29d85"

export default script